'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$89() {
  this.bJI = null;
  this.bJJ = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$89 as $c_Lpresto_TwoFactorAuthView$$anon$89 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$89.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$89;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$89() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$89 as $h_Lpresto_TwoFactorAuthView$$anon$89 };
$h_Lpresto_TwoFactorAuthView$$anon$89.prototype = $p;
$p.P = (function() {
  if ((!this.bJJ)) {
    this.bJI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bJJ = true;
  }
  return this.bJI;
});
var $d_Lpresto_TwoFactorAuthView$$anon$89 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$89, "presto.TwoFactorAuthView$$anon$89", ({
  TC: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$89 as $d_Lpresto_TwoFactorAuthView$$anon$89 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$89.js.map
